import { typedAction } from './common/actions';
import { RootState } from '../redux/reducers';
import Logger from '../../../shared/utils/logger';
import { IAggregation } from '../../../shared/types/Aggregation';
import { Nullable } from '../../../shared/types/Typescript-utils';

export enum AggregationsStatus {
  FETCHING = 'AGGREGATIONS_FETCHING',
  SUCCESS = 'AGGREGATIONS_SUCCESS',
  ERROR = 'AGGREGATIONS_ERROR',
}

interface AggregationsState {
  data: readonly IAggregation[];
  status: Nullable<AggregationsStatus>;
  error: Nullable<Error>;
}

const initialState: AggregationsState = {
  data: [],
  status: null,
  error: null,
};

export const FETCHING = 'aggregations/fetching';
export const FETCHING_SUCCESS = 'aggregations/success';
export const FETCHING_ERROR = 'aggregations/error';

export const fetchAggregations = () => {
  return typedAction(FETCHING);
};

export const fetchAggregationsSuccess = (payload: { aggregations: ReadonlyArray<IAggregation> }) => {
  return typedAction(FETCHING_SUCCESS, payload);
};

export const fetchAggregationsError = (payload: Error) => {
  Logger.warning(payload);
  return typedAction(FETCHING_ERROR, payload);
};

export type AggregationsAction = ReturnType<
  typeof fetchAggregations | typeof fetchAggregationsSuccess | typeof fetchAggregationsError
>;

export const aggregationsSelector = (state: RootState) => state.aggregations?.data;
export const ratingAggregationsSelector = (state: RootState) =>
  state.aggregations?.data?.filter(e => e.id === 'rating');

export function aggregationsReducer(state = initialState, action: AggregationsAction): AggregationsState {
  switch (action.type) {
    case FETCHING:
      return { ...state, status: AggregationsStatus.FETCHING };
    case FETCHING_SUCCESS:
      return {
        ...state,
        status: AggregationsStatus.SUCCESS,
        data: action.payload.aggregations,
      };
    case FETCHING_ERROR:
      return { ...state, status: AggregationsStatus.ERROR, error: action.payload };
    default:
      return state;
  }
}
